import { Select, Text } from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { FIELD, GENDER_FIELD_VALUE } from '../constants/field';
import FormField from './FormField';

const GenderSelector = ({ required }) => {
  const { t } = useTranslation();
  const { errors, register } = useFormContext();
  const name = t('users.membership.member_info.gender');
  const label = `${name} ${
    required ? '' : t('membership.profile.optional_field')
  }`;

  return (
    <FormField label={label} hasError={Boolean(errors[FIELD.GENDER])}>
      <Select
        name={FIELD.GENDER}
        ref={register}
        data-e2e-id="member-center-profile-gender_field"
      >
        <option disabled value="">
          {t('dropdown.hint')}
        </option>
        <option value={GENDER_FIELD_VALUE.MALE}>
          {t('users.membership.member_info.gender.male')}
        </option>
        <option value={GENDER_FIELD_VALUE.FEMALE}>
          {t('users.membership.member_info.gender.female')}
        </option>
        <option value={GENDER_FIELD_VALUE.OTHER}>
          {t('users.membership.member_info.gender.other')}
        </option>
      </Select>
      {errors[FIELD.GENDER] && (
        <Text variant="errorMessage" textAlign="right">
          {t(errors[FIELD.GENDER].message, {
            field_name: name,
          })}
        </Text>
      )}
    </FormField>
  );
};

GenderSelector.propTypes = {
  required: PropTypes.bool,
};

export default GenderSelector;
